const FilterByPrice = (props) => {
    const { selectedPriceRanges, handlePriceCheckboxChange } = props;

    return (
        <div>
            <div className="widget sidebar-tags">
                <div className="widget-title open">
                    <h3 className="sidebar-title text-uppercase">
                        <span>Shop by Price</span>
                    </h3>
                </div>
                <div className="widget-content widget_content_animate d-block">
                    <ul className="list-tags p-0 list-unstyled">
                        {['0-999', '999-1499', '1499-1999', '1999-2499', '2499+'].map((range, i) => (
                            <li className="item" key={i}>
                                <input
                                    type="checkbox"
                                    value={range}
                                    checked={selectedPriceRanges.includes(range)}
                                    onChange={() => handlePriceCheckboxChange(range)}
                                />
                                <label>{range.replace('-', ' to ').replace('+', ' Above')}</label>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default FilterByPrice;